import {
    DATA_TYPE,
    COMMUNICATION_FORMAT,
    DATA_FORMAT,
    DOMAIN_MAX_LENGTH,
} from "../../constants";

export const processSchema = {
    "documentProcessHistory": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "type": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentProcessHistoryType",
            value: null,
        },
        "userAgent": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "ip": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "referenceType": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentProcessHistoryReferenceType",
            value: null,
        },
        "referenceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "message": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.MESSAGE,
            value: "",
        },
        "documentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    }
} as const;
